import { Home as HomeIcon } from "@mui/icons-material";
import { Home as HomeV2 } from "../pages/HomeV2";
import { Route } from "../types/Route";

const routes: Array<Route> = [
  {
    key: "router-home-v2",
    title: "Home",
    description: "Home",
    component: HomeV2,
    path: "/",
    isEnabled: true,
    icon: HomeIcon,
    appendDivider: true,
  },
];

export default routes;
